export default defineNuxtRouteMiddleware((to) => {
  const cookieRef = useCookie('source');
  const { utm_source, utm_campaign, utm_content } = to.query;

  if (utm_source) {
    cookieRef.value = `${utm_source}_${utm_campaign || ''}_${utm_content || ''}`;
  }
});
